import { createContext, useContext, ReactNode, useMemo } from 'react';

export interface AppContextInfo {
    locale: string;
}

const AppContext = createContext<AppContextInfo>({
    locale: 'en_US',
});

interface AppContextProviderProps {
    children: ReactNode;
    locale: string;
}

export function AppContextProvider({ children, locale }: AppContextProviderProps) {
    const value = useMemo(() => ({ locale }), [locale]);
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppContext(): AppContextInfo {
    const value = useContext(AppContext);
    if (!value) {
        throw new Error('useAppContext must be used within an AppContextProvider');
    }
    return value;
}
